module.exports = __webpack_public_path__ + "images/search-7ecffb7b.svg";